<template>
  <div class="wrapper">
    <el-empty description="敬请期待"></el-empty>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  data() {
    return {}
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  $red: #f56c6c;
  $green: #67c23a;
  .plus {
    color: $red;
  }
  .minus {
    color: $green;
  }
  .bg1 {
    background: linear-gradient(to bottom, #f2f9fe, #e6f4fe);
  }
  .bg2 {
    background: linear-gradient(to bottom, #f4fef1, #e7feee);
  }
  .bg3 {
    background: linear-gradient(to bottom, #f1f8fe, #e6f4fe);
  }
  .bg4 {
    background: linear-gradient(to bottom, #f5f5ff, #ececff);
  }
  .bg5 {
    background: linear-gradient(to bottom, #f6f6fc, #fae8d2);
  }
  .top /deep/ {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    .right {
      .date {
        margin-top: 5px;
      }
    }
    .title {
      margin-bottom: 0;
    }
  }
  .hexin-box {
    display: grid;
    margin-top: 20px;
    margin-bottom: 20px;
    gap: 10px;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    justify-content: center;
    .item {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 10px;
      border-radius: 5px;
      height: 220px;
      .row {
        flex: 1;
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
        &:last-child {
          margin-bottom: 0;
        }
        .left,
        .col {
          // flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .title {
            // text-align: center;
            font-size: 14px;
            .xiadan {
              position: relative;
              .num {
                position: absolute;
                bottom: -42px;
                left: 50%;
                transform: translateX(-50%);
                font-weight: 700;
                margin: 5px 0;
                // text-align: center;
                font-size: 22px;
              }
            }
          }
          .value {
            position: relative;
            font-weight: 700;
            margin: 5px 0;
            text-align: center;
            font-size: 22px;
          }
          .cmpday {
            display: flex;
            align-items: center;
            justify-content: center;
            .sub-title {
              font-size: 12px;
              color: #888;
            }
            .sub-value {
              font-size: 12px;
              margin: 0 5px;
            }
            .icon {
              display: flex;
              align-items: center;
              justify-content: center;
              i {
                font-size: 15px;
              }
            }
          }
        }

        .right {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          min-width: 150px;
          // flex: 1;
          .title {
            padding-left: 20px;
            text-align: left;
          }
          .chart {
            display: flex;
            align-items: center;
            .bar {
              width: 80px;
              height: 80px;
            }
            .desc {
              display: flex;
              flex-direction: column;
              margin-left: 10px;
              font-size: 12px;
              .desc-item {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-bottom: 5px;
                &:last-child {
                  margin-bottom: 0;
                }
                .label {
                  font-size: 10px;
                  color: #888;
                }
                .value {
                  font-weight: 600;
                  font-size: 14px;
                }
              }
            }
          }
        }
      }
      .line-chart {
        // background: pink;
        height: 110px;
        width: 100%;
      }
    }
  }
}
</style>
